import { DATE_RANGE_PRESETS } from "./constants"

/** Ids arrive as numbers from one API and strings from another, so compare them as strings. */
export const isSameFilterId = (left, right) => String(left) === String(right)

export const includesFilterId = (ids = [], id) => ids.some((candidate) => isSameFilterId(candidate, id))

export const toggleFilterId = (ids = [], id) => (includesFilterId(ids, id) ? ids.filter((candidate) => !isSameFilterId(candidate, id)) : [...ids, id])

/**
 * The preset a chosen range happens to equal, so a pill can read "Rest of Year" instead of its
 * dates and the matching preset button can show as selected. `null` when the range is custom.
 */
export const findMatchingPreset = (range, today) => {
  if (!range?.[0] || !range?.[1]) return null
  return (
    DATE_RANGE_PRESETS.find((preset) => {
      const [start, end] = preset.getRange(today)
      return range[0].isSame(start, "day") && range[1].isSame(end, "day")
    }) || null
  )
}
